
export function InitiateAnalyticsCheck(window:any) {
    if(window.isAnalyticsLoaded === undefined) {
        window.isAnalyticsLoaded = Promise.race([
            new Promise(resolve => {
                const isLoaded = () => {
                    if (window.ga && window.ga.loaded) {
                        console.log('window.ga.loaded: ', window.ga.loaded);
                        resolve("GA-LOADED");
                    } else {
                        setTimeout(isLoaded, 200);
                    }
                };
                isLoaded();
            })
        ]);
    }
}
